// extracted by mini-css-extract-plugin
export default {"item":"GettingStarted_item__21a6H","show":"GettingStarted_show__OAJOC"};